// extracted by mini-css-extract-plugin
export var cardBackgroundFilter = "BackgroundCard-module--card-background-filter--93593";
export var cardText = "BackgroundCard-module--card-text--f88c5";
export var cardTitle = "BackgroundCard-module--card-title--2645b";
export var tabletOnly = "BackgroundCard-module--tablet-only--779bd";